<script setup lang="ts">
defineProps({
  active: { type: String, required: true },
  showMenu: { type: Boolean, required: true },
  user: {
    type: Object as PropType<ReturnType<typeof useAuth>['data']['value']>,
    default: null,
    required: false
  }
})

const emit = defineEmits(['closeMenu', 'handleLogout'])

const lmsDomain = useRuntimeConfig().public.lmsDomain
const jobAdminDomain = useRuntimeConfig().public.jobAdminDomain

const clickLink = (link: string) => {
  emit('closeMenu')
  navigateTo(link)
}
</script>

<template>
  <div id="admin-navbar-links" :class="`anim-fade-down ${showMenu ? 'show-links' : 'hide-links'}`">
    <NuxtLink
      v-if="isCourseAdmin(user) || isInstructor(user)"
      class="nav-item clickable"
      :to="`${lmsDomain}/classroom/course-admin/course-grading`"
    >
      Grade assignments
    </NuxtLink>

    <NuxtLink
      v-if="isCourseAdmin(user) || isTalentAdmin(user)"
      class="nav-item clickable"
      :to="`${lmsDomain}/classroom/course-admin/students`"
    >
      Manage talents
    </NuxtLink>

    <NuxtLink
      v-if="isCompanyStaff(user) || isJobAdmin(user)"
      class="nav-item clickable"
      :to="jobAdminDomain"
    >
      Manage jobs
    </NuxtLink>

    <div class="nav-item clickable" @click="clickLink('/jobs/browse')">Jobs</div>

    <div
      v-if="isUserAccessSkills(user)"
      class="nav-item clickable"
      @click="clickLink('/skills/admin/assessments')"
    >
      Skills
    </div>

    <!-- <div class="nav-item clickable" @click="clickLink('/events')">Events</div> -->

    <div
      class="nav-item clickable"
      @click="clickLink(isClassAdmin(user) ? '/forum/admin' : '/forum/feed')"
    >
      Forum
    </div>
  </div>
</template>

<style scoped lang="scss">
#admin-navbar-links {
  gap: 50px;
  height: 100%;

  .nav-item {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 0.95rem;
  }

  #logout,
  #settings {
    display: none;
  }
}

.hide-links,
.show-links {
  display: flex;
}

@media (max-width: 1250px) {
  #admin-navbar-links {
    padding-left: 50px;
    gap: 40px;
  }
}

@media (max-width: 900px) {
  #admin-navbar-links {
    background: white;
    position: fixed;
    height: calc(100dvh - var(--navbarHeight));
    width: 100dvw;
    top: var(--navbarHeight);
    left: 0;
    gap: 0;
    flex-direction: column;
    padding: 10px 0 0;
    overflow-y: scroll;
    padding: 0;

    .nav-item {
      display: block;
      height: auto;
      padding: 30px;
      border-bottom: 1px solid var(--borderL2);
    }

    #settings,
    #logout {
      display: block;
    }
  }

  .hide-links {
    display: none;
  }

  .show-links {
    display: flex;
  }
}
</style>
